import React from 'react';

import ReportTimeRangeListDropdown from './reportTimeRangeListDropdown'
import getDates from './../../../shared/services/date.service';

import styles from './reportTimeRangeList.module.scss';

// days - how many days ago a time period began
// isFull - true if the time period duration and the date variable are equal, false if the time period lasts one day
const getTimeRangeDates = (days, isFull) => {
  let date = new Date()
  let duration = isFull ? days - 1 : days // fix the number of days to set the end of the time period to the current date
  let rangeStartDate = new Date(date.getTime() - (duration * 24 * 60 * 60 * 1000))
  let startDate = getDates.getNullTimeDate(rangeStartDate)
  let rangeEndDate = new Date()
  let endDate = isFull ? getDates.getEndDayTimeDate(rangeEndDate) : getDates.getEndDayTimeDate(startDate)

  return {
    startDate,
    endDate
  }
}

const ReportTimeRangeList = props => {
  const { onHandleChangeStore } = props

  const setDates = (days, isFull) => {
    let dates = getTimeRangeDates(days, isFull)

    onHandleChangeStore(
      ['reportStartDate', 'reportStartTime', 'reportEndDate', 'reportEndTime'],
      [dates.startDate, dates.startDate, dates.endDate, dates.endDate]
    )
  }

  return (
    <div className={styles.rangeList}>
      <div className={styles.rangeListItem}>
        <span onClick={setDates.bind(this, 0, false)}>Сегодня</span>
      </div>
      <div className={styles.rangeListItem}>
        <span onClick={setDates.bind(this, 1, false)}>Вчера</span>
      </div>
      <div className={styles.rangeListItem}>
        <span onClick={setDates.bind(this, 7, true)}>Последние 7 дней</span>
      </div>
      <div className={styles.rangeListItem}>
        <span onClick={setDates.bind(this, 31, true)}>Текущий месяц</span>
      </div>
      <div className={styles.rangeListItem_dropdown}>
        <ReportTimeRangeListDropdown title='Иные' handleClick={setDates} />
      </div>
    </div>
  )
}

export default React.memo(ReportTimeRangeList)